import {SearchModel} from "../components";

export class SearchUtil {

    public static searchList(list: any[], search: SearchModel) {
      if(search.filters) {
        for (let i = 0; i < search.filters.length; i++) {
          let f1 = search.filters[i];

          list = list.filter(a1 => {
            if(a1[f1.entity] && typeof(a1[f1.entity]) == 'number')
              {
                return a1[f1.entity] == f1.value;
              }
              else {
                if(typeof(a1[f1.entity]) !== 'number'){
                   return (a1[f1.entity].toLowerCase() ?? 'UNKNOWN').indexOf(f1.value.toLowerCase()) != -1;
                }

              }
          });
        }

      }
      if(search.order) {
        let sortProperty = search.order.entity;
        list.sort(( a, b ) =>
        {
          if (typeof (a[sortProperty]) === 'string' && typeof (b[sortProperty]) === 'string') {
            if (!a[sortProperty]) {
              a[sortProperty] = '';
            }
            if (!b[sortProperty]) {
              b[sortProperty] = '';
            }
            if (a[sortProperty].toLowerCase() < b[sortProperty].toLowerCase()) {
              return -1;
            }
            if (a[sortProperty].toLowerCase() > b[sortProperty].toLowerCase()) {
              return 1;
            }
          }
          return 0;
        }
        );
        if(search.order.direction == 'DESC') {
          list.reverse();
        }
      }
      return list;
    }
}
